import AppConstants from '../constants/AppConstants';

export const initialState = {
    active: false,
    total: 0,
    uploaded: 0
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.PACE_PROGRESS_ACTIVE:
            return {
                ...state,
                active: true
            };

        case AppConstants.PACE_PROGRESS_TOTAL_INCREMENT:
            return {
                ...state,
                total: state.total + 1
            };

        case AppConstants.PACE_PROGRESS_UPLOADED_INCREMENT:
            return {
                ...state,
                uploaded: state.uploaded + 1
            };

        case AppConstants.PACE_PROGRESS_CLEAR:
            return {
                ...initialState
            };

        default:
            return state;
    }
};
